import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface IGetTaskListInterface {
  page?: number;
  page_size?: number;
  is_failed?: number;
}

interface IRetryTaskInterface {
  id: string;
}

const GET_TASK_LIST_API = "/api/task/list";
const RETRY_TASK_API = "/api/task/retry";

@Injectable({
  providedIn: "root",
})
export class SynTaskService {
  constructor(private http: HttpClient) {}

  // 获取任务列表
  getTaskList(params: IGetTaskListInterface) {
    const query = new HttpParams()
      .append("page", `${params.page}`)
      .append("page_size", `${params.page_size}`)
      .append("is_failed", `${params.is_failed}`);
    return this.http.get(GET_TASK_LIST_API, { params: query }) as Observable<
      IHttpResponse
    >;
  }

  // 重试任务
  retryTask(params: IRetryTaskInterface) {
    return this.http.post(RETRY_TASK_API, params) as Observable<IHttpResponse>;
  }
}
